import React from 'react';

/** Horizontal scrolling filter chips. options: string[]; '' = All. */
export default function Chips({ options, value, onChange, allLabel = 'All' }) {
  const items = [{ key: '', label: allLabel }, ...options.map((o) => ({ key: o, label: o }))];
  return (
    <div className="chips" role="tablist">
      {items.map((it) => (
        <button
          key={it.key || 'all'}
          type="button"
          role="tab"
          aria-selected={value === it.key}
          className={`chip ${value === it.key ? 'chip--active' : ''}`}
          onClick={() => onChange(it.key)}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
